var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"notification\"><div class=\"content form-content active\"><flash-message></flash-message><ra-pagination total=\"{{total_count}}\" options=\"pagination_options\"></ra-pagination><div class=\"cf\"></div><notifications-table displayed=\"notifications\"></notifications-table></div><div class=\"button-blue\"><div class=\"container\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/notifications/notifications.jade
// module id = 993
// module chunks = 0